/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Gpx_Import_Failed_OtherInputs */

const en_toast_gpx_import_failed_other = /** @type {(inputs: Toast_Gpx_Import_Failed_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} routes failed to import`)
};

const de_toast_gpx_import_failed_other = /** @type {(inputs: Toast_Gpx_Import_Failed_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Routen konnten nicht importiert werden`)
};

/**
* | output |
* | --- |
* | "{count} routes failed to import" |
*
* @param {Toast_Gpx_Import_Failed_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_gpx_import_failed_other = /** @type {((inputs: Toast_Gpx_Import_Failed_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Gpx_Import_Failed_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_gpx_import_failed_other(inputs)
	return de_toast_gpx_import_failed_other(inputs)
});